import { FRAUD_REASON } from '@savgroup-front-common/types';

import { safeFormattedIntlString } from '../safeFormattedIntlString';

import messages from './messages';

export const formatFraudReason = (reason?: FRAUD_REASON) => {
  switch (reason) {
    case FRAUD_REASON.BRICKING:
      return safeFormattedIntlString(messages.fraudReasonBricking);
    case FRAUD_REASON.CONTENT_SUBSTITUTION:
      return safeFormattedIntlString(messages.fraudReasonContentSubstitution);
    case FRAUD_REASON.DOCUMENT_FALSIFICATION:
      return safeFormattedIntlString(messages.fraudReasonDocumentFalsification);
    case FRAUD_REASON.COUNTERFEIT:
      return safeFormattedIntlString(messages.fraudReasonCounterfeit);
    case FRAUD_REASON.WARDROBING:
      return safeFormattedIntlString(messages.fraudReasonWardrobing);
    default:
      return safeFormattedIntlString(messages.notSpecified);
  }
};
